module.exports = __webpack_public_path__ + "img/jump_icon.86e60a82.png";